import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import "../Styles/SecuritySettings.css";
import { ThemeContext } from "../../../../../context/ThemeContext";

const SecuritySelector = () => {
    const [isSubscribed, setIsSubscribed] = useState(true);
    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const [profilevisibility, setprofilevisibility] = useState("public");
    const [personalInfoVisibility, setpersonalInfoVisibility] = useState("public");
    const [privacysettings, setprivacysettings] = useState(false);
    const [locationtracker, setlocationtrackers] = useState(false);
    const [tracklocationhistory, setlocationhistory] = useState(false);
    const [allowgeotagging, setgeotagging] = useState(false);
    const [adpreferences, setadpreferences] = useState(false);
    const [adconnect, setadconnect] = useState(false);
    const [blockad, setblockad] = useState(false);
    const [searchprofile, setsearchprofile] = useState(false);
    const [facialtrack, setfacialtrack] = useState(false);
    const [aifeeder, setaifeeder] = useState(false);
    const [autotagging, setautotagging] = useState(false);
    const [accountdeletion, setaccountdeletion] = useState(false);
    const [profiledeletion, setprofiledeletion] = useState(false);
    const [privacyonmessage, setprivacyonmessage] = useState(false);
    const [allowfeedtollmmodel, setallowfeedtollmmodel] = useState(false);
    const [errorMessage, setErrorMessage] = useState(""); // Added error handling
    const [selectedCheckbox, setSelectedCheckbox] = useState(null);
    const { theme } = useContext(ThemeContext);

    const handleSubmit = async (event) => {
      event.preventDefault();
  
      if (!acceptedTerms) {
        setErrorMessage('You must accept the Terms and Conditions to continue.');
        return;
      }
    
      const userData = {
        privacysettings,
        profilevisibility,
        personalInfoVisibility,
        locationtracker, 
        tracklocationhistory, 
        allowgeotagging,
        adpreferences,
        adconnect,
        blockad,
        searchprofile,
        facialtrack,
        aifeeder,
        autotagging,
        accountdeletion,
        profiledeletion,
        privacyonmessage,
        allowfeedtollmmodel,
      };
  
      try {
        const response = await fetch("/api/v1/user/account/config/add", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(userData), 
        });
  
        const result = await response.json();
        if (response.ok) {
          alert("Privacy Settings applied successfully!");
        } else {
          alert("Privacy Settings failed: " + result.message);
        }
      } catch (error) {
        setErrorMessage(error.message || 'Privacy Settings failed.');
      }
  
      setErrorMessage('');
    };

    useEffect(() => {
      // Dynamically import the correct theme CSS
      import(`../Styles/themes/${theme}/themes.css`)
      .then(() => {
        console.log(`Loaded ${theme} styles for UserProfile`);
      })
      .catch(() => {
        console.error(`Theme CSS not found for ${theme}`);
      });
    }, [theme]);

  return (
    <div className="st-privacy-settings-container" overflow-y= "scroll">
      {/* Company Logo */}
      <div style={{marginBottom: 20}}>      
        <p className="st-text" >
        Oowlet has been committed for privacy of users personal data. We don't collect and autherize anyone to collect any unwarrented data specific to 
        any user in any means. Even We have taken all necessary actions to secure the limited data that we collect from user. Most of the data being 
        used for our analytics purpose specific to recommendation engines for user and content suggestion. If you find any discrepency and 
        any misuse of data from our behalf, you can write to us on .. We will take the necessary action, as we feel personal data is the 
        intellectual property of each user. We ensure the secrecy and safety of users personal data.     
      </p>
      </div>
      
      {isSubscribed && (
      <div>
      <input type="checkbox"/>
      <label style={{color: "white", marginLeft: 10}}>
          Base Policies. 
      </label>

      <input type="checkbox" style={{color: "white", marginLeft: 10}}/>
      <label style={{color: "white", marginLeft: 10}}>
          Subscribed Policies.  
      </label>
      </div>
      )}

      <h3 style={{color: "white", marginTop: 20}}>1. Profile Visibility </h3>
      <div>
      <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row", marginTop: 10}}>
        <input 
          type="checkbox"
          checked={profilevisibility === "public"}
          onChange={() => setprofilevisibility("public")}
        />
          <span style={{color: "white", marginLeft: 10}}>
          Public
          </span>
      </label>
      <br />
      </div>
      <div>
        <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
          <input 
            type="checkbox"
            checked={profilevisibility === "friends only"}
            onChange={() => setprofilevisibility("friends only")}
          />
          <span style={{color: "white", marginLeft: 10}}>
          Friends only
          </span>
        </label>
      </div>

      <h3 className= "st-text-label" style={{color: "white", marginTop: 20}}>2. Personal Information Visibility </h3>
      <div>
        <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
          <input
            type="checkbox"
            checked={personalInfoVisibility === "Public"}
            onChange={() => setpersonalInfoVisibility("Public")}
          />
          <span style={{color: "white", marginLeft: 10}}>
          Public
          </span>
        </label>
        <br />
        <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
          <input type="checkbox"
            checked={personalInfoVisibility === "friends only"}
            onChange={() => setpersonalInfoVisibility("friends only")}
          />
          <span style={{color: "white", marginLeft: 10}}>
          Friends only
          </span>
        </label>
        <br />
        <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
        <input type="checkbox"
          checked={personalInfoVisibility === "Private (only me)"}
          onChange={() => setpersonalInfoVisibility("Private (only me)")}
        />
        <span style={{color: "white", marginLeft: 10}}>
          Private (only me)
          </span>
        </label>
        <br />
        <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
         <input type="checkbox"
            checked={personalInfoVisibility === "Custom (specific friends)"}
            onChange={() => setpersonalInfoVisibility("Custom (specific friends)")}
        />
        <span style={{color: "white", marginLeft: 10}} >
          Custom (specific friends)
        </span>
        </label>
        <br />
      </div>

      {isSubscribed && (
      <div>
      <h3 className= "st-text-label" style={{color: "white"}}>3. Location and Tracking. </h3>
      <div>
        <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
        <input type="checkbox"
          checked={locationtracker}
          onChange={() => setlocationtrackers(!locationtracker)}
          fontFamily = "Poppins"
          fontSize = "15px"
        />
        <span style={{color: "white", marginLeft: 10}}>
          Location Tracking.  
        </span>
        </label>
        {locationtracker && (
        <div>
          <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row", marginTop: 10}}>
         <input
            checked={locationtracker === "Enable"}
            onChange={() => setlocationtrackers("Enable")} 
            style={{marginLeft: 30}}
            type="checkbox"/>
            <span style={{color: "white", marginLeft: 10}}>  
              Enable
            </span>
         </label>
         <br />
         <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}> 
         <input 
            checked={locationtracker === "Disable"}
            onChange={() => setlocationtrackers("Disable")} 
            style={{marginLeft: 30}}
            type="checkbox"/>
          <span style={{color: "white", marginLeft: 10}}>
           Disable
           </span>
         </label>
         <br />
         </div>
      )}
      </div>
      <div>
        <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
        <input 
          type="checkbox"
          checked={tracklocationhistory}
          onChange={() => setlocationhistory(!tracklocationhistory)}
          fontFamily = "Poppins" 
          fontSize = "15px"
        />
        <span style={{color: "white", marginLeft: 10}}>
          Location History. 
        </span>
        </label>
        {tracklocationhistory && (
        <div>
          <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row", marginTop: 10}}>
          <input 
            checked={tracklocationhistory === "Enable"}
            onChange={() => setlocationhistory("Enable")} 
            type="checkbox" style={{marginLeft: 30}}/> 
          <span style={{color: "white", marginLeft: 10}}>
           Enable
          </span>
         </label>
         <br />
         <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
         <input 
            checked={tracklocationhistory === "Disable"}
            onChange={() => setlocationhistory("Disable")} 
            type="checkbox" style={{marginLeft: 30 }}/>
            <span style={{color: "white", marginLeft: 10}}>
           Disable
           </span>
         </label>
         <br />
         </div>
      )}
      </div>

      <div>
      <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
      <input 
        type="checkbox"
        checked={allowgeotagging}
        onChange={() => setgeotagging(!allowgeotagging)}
      />
        <span style={{color: "white", marginLeft: 10}}>
          Geotagging for posts and Photos. 
        </span> 
      </label>
      {allowgeotagging && (
        <div>
          <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row", marginTop: 10}}>
          <input 
            checked={allowgeotagging === "Enable"}
            onChange={() => setgeotagging("Enable")} 
            type="checkbox" style={{marginLeft: 30 }}/> 
            <span style={{color: "white", marginLeft: 10}}>
            Enable
            </span>
         </label>
         <br />
         <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}> 
         <input 
          checked={allowgeotagging === "Disable"}
          onChange={() => setgeotagging("Disable")} 
          type="checkbox" style={{marginLeft: 30 }}/>
          <span style={{color: "white", marginLeft: 10}}>
           Disable
          </span>
         </label>
         <br />
         </div>
      )}
      </div>
      <h3 className= "st-text-label" style={{color: "white"}}>4. Personalize Ad Preferences </h3>
      <div>
      <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
      <input 
        type="checkbox"
        checked={adpreferences}
        onChange={() => setadpreferences(!adpreferences)}
      />
      <span style={{color: "white", marginLeft: 10}}>
        Ad personalization <Link to="/privacy-policy" style={{marginLeft: "5px" }} target="_blank">(?)</Link>
      </span>
      </label>
      {adpreferences && (
        <div>
          <div style={{ marginBottom: "10px" }}>
          <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row", marginTop: 20}}>
          <input 
            checked={adpreferences === "Profile based ads"}
            onChange={() => setadpreferences("Profile based ads")} 
            type="checkbox" style={{ marginLeft: 25 }} />
            <span style={{color: "white", marginLeft: 10}}>
              Profile based ads
            </span>
          </label>
          <br />
          </div>
          <div style={{ marginBottom: "10px" }}>
          <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
          <input 
            checked={adpreferences === "Interest based Ads (browsing history)"}
            onChange={() => setadpreferences("Interest based Ads (browsing history)")} 
          type="checkbox" style={{ marginLeft: 25 }}/>
          <span style={{color: "white", marginLeft: 10}}>
            Interest based Ads (browsing history)
          </span>
          </label>
          <br />
          </div>
          <div>
          <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
          <input 
          checked={adpreferences === "Random Ads"}
          onChange={() => setadpreferences("Random Ads")} 
          type="checkbox" style={{ marginLeft: 25 }}/>
          <span style={{color: "white", marginLeft: 10}}>
            Random Ads
          </span>
          </label>
          <br />
          </div>
         </div>
      )}
      <div>
      <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
      <input 
        type="checkbox"
        checked={adconnect}
        onChange={() => setadconnect(!adconnect)}
      />
      <span style={{color: "white", marginLeft: 10}}>
          Advertisers direct connect.
      </span>   
      </label>
      {adconnect && (
        <div>
          <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row", marginTop: 20}}> 
          <input 
          checked={adconnect === "Enable"}
          onChange={() => setadconnect("Enable")} 
          type="checkbox" style={{marginLeft: 30}}/>
        <span style={{color: "white", marginLeft: 10}}>
           Enable
           </span>
          </label>
          <br />
          <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
          <input 
          checked={adconnect === "Disable"}
          onChange={() => setadconnect("Disable")} 
          type="checkbox" style={{marginLeft: 30 }}/> 
          <span style={{color: "white", marginLeft: 10}}>
           Disable
           </span>
         </label>
         <br />
         </div>
      )}
      </div>
      </div>
      <div>
      <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
      <input 
        type="checkbox"
        checked={blockad}
        onChange={() => setblockad(!blockad)}
      />
      <span style={{color: "white", marginLeft: 10}}>
        Block specific advertisers.
        </span>    
      </label>
      {blockad && (
        <div>
          <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row", marginTop: 20}}> 
          <input 
          checked={blockad === "Enable"}
          onChange={() => setblockad("Enable")} 
          type="checkbox" style={{marginLeft: 30 }}/>
          <span style={{color: "white", marginLeft: 10}}>
           Enable
           </span>
         </label>
         <br />
         <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
         <input 
          checked={blockad === "Disable"}
          onChange={() => setblockad("Disable")}
          type="checkbox" style={{marginLeft: 35}}/>
          <span style={{color: "white", marginLeft: 10}}>
           Disable
           </span>
         </label>
         <br />
         </div>
      )}
      </div>

      <h3 className= "st-text-label" style={{color: "white"}}>5. Search & Discoverability Settings </h3>
      <div>
      <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
      <input 
        type="checkbox"
        checked={searchprofile}
        onChange={() => setsearchprofile(!searchprofile)}
      />
        <span style={{color: "white", marginLeft: 10}}>
          Searchability of your profile.
        </span>   
      </label>
      {searchprofile && (
        <div>
          <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row", marginTop: 20}}>
          <input 
          checked={searchprofile === "Enable"}
          onChange={() => setsearchprofile("Enable")}
          type="checkbox" style={{marginLeft: 30}}/> 
          <span style={{color: "white", marginLeft: 10}}>
           Enable
           </span>
         </label>
         <br />
         <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
         <input 
          checked={searchprofile === "Disable"}
          onChange={() => setsearchprofile("Disable")}
         type="checkbox" style={{marginLeft: 30}}/>
         <span style={{color: "white", marginLeft: 10}}> 
           Disable
          </span>
         </label>
         <br />
         </div>
      )}
      </div>

      <h3 className= "st-text-label" style={{color: "white"}}>6. Facial recognition and AI tracking </h3>
      <div>
      <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
      <input 
        type="checkbox"
        checked={aifeeder}
        onChange={() => setaifeeder(!aifeeder)}
      />
      <span style={{color: "white", marginLeft: 10}}>
          Use of AI for any means.
      </span>   
      </label>
      {aifeeder && (
        <div>
          <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row", marginTop: 20}}>
          <input  
          checked={aifeeder === "Enable"}
          onChange={() => setaifeeder("Enable")} 
          type="checkbox" style={{marginLeft: 30}}/> 
          <span style={{color: "white", marginLeft: 10}}>
           Enable
           </span>
         </label>
         <br />
         <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}> 
         <input 
         checked={aifeeder === "Disable"}
         onChange={() => setaifeeder("Disable")}
         type="checkbox" style={{marginLeft: 30}}/> 
         <span style={{color: "white", marginLeft: 10}}>
           Disable
          </span>
         </label>
         <br />
         </div>
      )}
      </div>
      <div>
      <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
      <input 
        type="checkbox"
        checked={facialtrack}
        onChange={() => setfacialtrack(!facialtrack)}
      />
      <span style={{color: "white", marginLeft: 10}}>
          Facial recognition.    
      </span>
      </label>
      {facialtrack && (
        <div>
          <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row", marginTop: 20}}> 
          <input
          checked={facialtrack === "Enable"}
          onChange={() => setfacialtrack("Enable")}
          type="checkbox" style={{marginLeft: 30}}/>
          <span style={{color: "white", marginLeft: 10}}>
           Enable
           </span>
         </label>
         <br />
         <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
         <input 
         checked={facialtrack === "Disable"}
         onChange={() => setfacialtrack("Disable")}
         type="checkbox" style={{marginLeft: 30 }}/>
         <span style={{color: "white", marginLeft: 10}}> 
           Disable
           </span>
         </label>
         <br />
         </div>
      )}
      </div>
      <div>
      <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
      <input 
        type="checkbox"
        checked={autotagging}
        onChange={() => setautotagging(!autotagging)}      
      />
      <span style={{color: "white", marginLeft: 10}}> 
        Auto-tagging in photos/videos
      </span>    
      </label>
      {autotagging && (
        <div>
          <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row", marginTop: 20}}> 
          <input 
         checked={autotagging === "Enable"}
         onChange={() => setautotagging("Enable")}
         type="checkbox" style={{marginLeft: 30 }}/>
         <span style={{color: "white", marginLeft: 10}}> 
           Enable
        </span>
         </label>
         <br />
         <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}> 
         <input
          checked={autotagging === "Disable"}
          onChange={() => setautotagging("Disable")}
          type="checkbox" style={{marginLeft: 30 }}/>
          <span style={{color: "white", marginLeft: 10}}> 
           Disable
           </span>
         </label>
         <br />
         </div>
      )}
      </div>

      <h3 className= "st-text-label" style={{color: "white"}}>7. Data Download & account Deletion. </h3>
      <div>
      <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
      <input
        type="checkbox"
        checked={accountdeletion}
        onChange={() => setaccountdeletion(!accountdeletion)}      
      />
      <span style={{color: "white", marginLeft: 10}}> 
        Request account deletion.  
      </span>  
      </label>
      {accountdeletion && (
        <div>
          <div>
          <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row", marginTop: 20}} > 
         <input
          checked={accountdeletion === "Allowed to autherize people"}
          onChange={() => setaccountdeletion("Allowed to autherize people")}         
         type="checkbox" style={{marginLeft: 30 }}/>
         <span style={{color: "white", marginLeft: 10}}> 
           Allowed to autherize people
           </span>
         </label>
         <br />
         </div>
         <div>
         <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
         <input 
          checked={accountdeletion === "Restricted to self deletion"}
          onChange={() => setaccountdeletion("Restricted to self deletion")}
         type="checkbox" style={{marginLeft: 30}}/>
         <span style={{color: "white", marginLeft: 10}}>  
           Restricted to self deletion
        </span>
         </label>
         </div>
         <br />
         </div>
      )}
      </div>
      <div>
      <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
      <input 
        type="checkbox"
        checked={profiledeletion}
        onChange={() => setprofiledeletion(!profiledeletion)}            
      />
      <span style={{color: "white", marginLeft: 10}}>
        Profile deletion.
      </span>    
      </label>
      {profiledeletion && (
        <div>
          <div>
          <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row", marginTop: 20}}> 
         <input 
          checked={profiledeletion === "Allowed to autherize people)"}
          onChange={() => setprofiledeletion("Allowed to autherize people)")}
         type="checkbox" style={{marginLeft: 30 }}/>
         <span style={{color: "white", marginLeft: 10}}>
           Allowed to autherize people
         </span>
         </label>
         <br/>
         </div>
         <div>
         <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
         <input 
          checked={profiledeletion === "Restricted to self deletion)"}
          onChange={() => setprofiledeletion("Restricted to self deletion)")}
         type="checkbox" style={{marginLeft: 30}}/> 
        <span style={{color: "white", marginLeft: 10}}>
           Restricted to self deletion
        </span>
         </label>
         <br/>
         </div>
         </div>
      )}
      </div>
      <h3 className= "st-text-label" style={{color: "white"}}>8. Encrypted Messaging & Communication Privacy</h3>
      <div>
      <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
      <input 
        type="checkbox"
        checked={privacyonmessage}
        onChange={() => setprivacyonmessage(!privacyonmessage)}      
      />
      <span style={{color: "white", marginLeft: 10}}> 
        Privacy of Profile info on DM.
      </span>     
      </label>
      {privacyonmessage && (
        <div>
          <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row", marginTop: 20}}>
          <input 
          checked={privacyonmessage === "Enable"}
          onChange={() => setprivacyonmessage("Enable")}
          type="checkbox" style={{marginLeft: 30}}/> 
          <span style={{color: "white", marginLeft: 10}}> 
           Enable
          </span>
         </label>
         <br />
         <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
         <input 
         checked={privacyonmessage === "Disable"}
         onChange={() => setprivacyonmessage("Disable")}
         type="checkbox" style={{marginLeft: 30}}/>
         <span style={{color: "white", marginLeft: 10}}> 
           Disable
          </span>
         </label>
         <br />
         </div>
      )}
      </div>

      <h3 className= "st-text-label" style={{color: "white"}}>9. Recommendation Strategy</h3>
      <div>
      <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}>
      <input 
        type="checkbox" 
        checked={allowfeedtollmmodel}
        onChange={() => setallowfeedtollmmodel(!allowfeedtollmmodel)}      
      />
      <span style={{color: "white", marginLeft: 10}}> 
        Allow Personal data to feed to LLM model.  
      </span>     
      </label>
      {allowfeedtollmmodel && (
        <div>
          <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row", marginTop: 20}}>
         <input 
          checked={allowfeedtollmmodel === "Enable"}
          onChange={() => setallowfeedtollmmodel("Enable")}
         type="checkbox" style={{marginLeft: 30}}/> 
         <span style={{color: "white", marginLeft: 10}}> 
           Enable
          </span>
         </label>
         <br />
         <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row"}}> 
         <input 
          checked={allowfeedtollmmodel === "Disable"}
          onChange={() => setallowfeedtollmmodel("Disable")}
          type="checkbox" style={{marginLeft: 30}}/>
          <span style={{color: "white", marginLeft: 10}}> 
           Disable
          </span>
         </label>
         <br />
         </div>
      )}
      </div>
      </div>
      )}

      {/* Terms & Conditions Checkbox */}
      <div className= "st-text-label" style={{marginTop: 35}}>
      <input type="checkbox" id="terms" checked={acceptedTerms} onChange={() => setAcceptedTerms(!acceptedTerms)}/>
        <label style={{color: "white", marginLeft: 10, display: "flex", flexDirection: "row", marginTop: 10}}>
          I accept the privacy settings. Kindly review. </label>
      </div>

      <button onClick={handleSubmit} className="st-submit">
            Submit
      </button>
      
      <div className= "st-text-label" style={{ fontFamily: "Poppins", display: "block", margin: "auto", fontSize: "14px", textAlign: "center" }}>
        <p className="cmn-copyright">
          Oowlet copyright To InitiumNet Technology Pvt Ltd. More information about privacy policies and cookies, click 
          <Link to="/" style={{ color: "blue", marginLeft: "5px" }}>here</Link>.
        </p>
      </div>   
    </div>
)}

export default SecuritySelector;